import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appServices from "../../services/app-services/appServices";

const initialState: any = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  categories: [],
};

export const getCategory = createAsyncThunk(
  "categories",
  async (_, thunkAPI) => {
    try {
      return await appServices.getCategory();
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const categoriesReducer = createSlice({
  name: "categories",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.categories = action.payload;
      })
      .addCase(getCategory.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { reset } = categoriesReducer.actions;

export default categoriesReducer.reducer;
